export default __webpack_public_path__ + "static/media/12.38b6bd78.png";